var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeVisible = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 14,
  viewBox: "0 0 20 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.4142 8.41421C11.0391 8.78929 10.5304 9 10 9C9.46957 9 8.96086 8.78929 8.58579 8.41421C8.21071 8.03914 8 7.53043 8 7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5C10.5304 5 11.0391 5.21071 11.4142 5.58579C11.7893 5.96086 12 6.46957 12 7C12 7.53043 11.7893 8.03914 11.4142 8.41421Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0C5.52201 0 1.73201 2.943 0.458008 7C1.73201 11.057 5.52201 14 10 14C14.478 14 18.268 11.057 19.542 7C18.268 2.943 14.478 0 10 0ZM12.8284 9.82843C13.5786 9.07828 14 8.06087 14 7C14 5.93913 13.5786 4.92172 12.8284 4.17157C12.0783 3.42143 11.0609 3 10 3C8.93914 3 7.92173 3.42143 7.17158 4.17157C6.42143 4.92172 6.00001 5.93913 6.00001 7C6.00001 8.06087 6.42143 9.07828 7.17158 9.82843C7.92173 10.5786 8.93914 11 10 11C11.0609 11 12.0783 10.5786 12.8284 9.82843Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeVisible);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-visible.2c06224d3e9ae7761854a5dbf1dabcf2.svg";